import { Injectable } from '@angular/core';
import { MessageService as PrimengMessageService } from 'primeng/api';
import { Message } from '../contract/message.contract';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private messageService: PrimengMessageService) {}

  public add(message: Message): void {
    this.messageService.add(message);
  }

  public addAll(messages: Message[]): void {
    this.messageService.addAll(messages);
  }

  public clear(): void {
    this.messageService.clear();
  }
}
